import styled from 'styled-components'
import Message from './Message'

const Chat = ({ messages }: { messages: ChatInterface[] }) => {
  return (
    <div>
      {messages.map((message) => (
        <Message key={`message-${message.id}`} message={message} />
      ))}
    </div>
  )
}

export default Chat
